import type { ScopedSecret } from '@reflex/shared';
import { ScopedSecretsManager } from '@/components/secrets/ScopedSecretsManager';
import type { CustomSecret } from '@/lib/types';

function toScopedSecret(secret: CustomSecret): ScopedSecret {
  const updatedAt = secret.updatedAt ?? 0;
  return {
    id: secret.key,
    name: secret.key,
    ownerId: 'org',
    createdAt: updatedAt,
    updatedAt,
  };
}

export function CustomSecretsSection({
  secrets,
  onUpdateSecret,
  onDeleteSecret,
  onAddSecret,
  isPending,
  editErrorMessage,
  onEditDialogOpenChange,
}: {
  secrets: CustomSecret[];
  onUpdateSecret: (key: string, value: string) => void | Promise<void>;
  onDeleteSecret: (key: string) => void;
  onAddSecret: (name: string, value: string) => void;
  isPending?: boolean;
  editErrorMessage?: (key: string) => string | null | undefined;
  onEditDialogOpenChange?: (open: boolean) => void;
}) {
  return (
    <ScopedSecretsManager
      title="Custom Secrets"
      secrets={secrets.map(toScopedSecret)}
      isPending={isPending}
      emptyState="No custom secrets configured. Add secrets for MCP servers, webhooks, or other services."
      editErrorMessage={editErrorMessage}
      onEditDialogOpenChange={onEditDialogOpenChange}
      onCreate={onAddSecret}
      onUpdate={onUpdateSecret}
      onDelete={onDeleteSecret}
    />
  );
}
